import React from 'react'
import ProductionStageCreatePage from './ProductionStageCreatePage'
import '../styles/_index.scss'

function ProductionStageCreateContainer(props) {
    const { params } = { ...props.match }
    const { id: stageId } = { ...params }

    return (
        <div className='ProductionStageCreateContainer'>
            <ProductionStageCreatePage stageId={stageId} />
        </div>
    )
}

export default ProductionStageCreateContainer